import styled from '@emotion/styled'

export const CustomLabel = styled.label`
	font-size: 16px;
	font-weight: 600;
`
